// extracted by mini-css-extract-plugin
export var newsBlockList = "blockListPaginated-module--newsBlockList--mOSTT";
export var newsBlockList__footer = "blockListPaginated-module--newsBlockList__footer--RjkfD";
export var newsBlockList__header = "blockListPaginated-module--newsBlockList__header--VcG3J";
export var newsBlockList__inactive = "blockListPaginated-module--newsBlockList__inactive--LwiyN";
export var newsBlockList__next = "blockListPaginated-module--newsBlockList__next--iD0bB";
export var newsBlockList__pagination = "blockListPaginated-module--newsBlockList__pagination--RlxjP";
export var newsBlockList__prev = "blockListPaginated-module--newsBlockList__prev--49xAg";